import React from 'react'
import { FormFeedback, FormGroup } from 'reactstrap'

const DesktopInputProduct = ({
  register,
  type = 'text',
  placeholder,
  disabled,
  className = '',
  error,
  step,
  ...rest
}) => {
  const name = register?.name || rest.name

  return (
    <FormGroup className="desktop-input-group">
      <input
        id={name}
        type={type}
        disabled={disabled}
        placeholder={placeholder}
        step={step}
        className={`form-control ${error ? 'is-error' : ''} ${className}`}
        {...register}
        {...rest}
        onWheel={(e) => e.target.blur()}
      />
      {error && <FormFeedback>{error}</FormFeedback>}
    </FormGroup>
  )
}

export default DesktopInputProduct
